module.exports = __webpack_public_path__ + "static/media/6.95cc7867.png";